export default __webpack_public_path__ + "static/media/chatIcon.a9abee73.svg";